import { InjectionToken } from '@angular/core';

import { AuthProvider } from './auth.provider';

export const AUTH_MODEL = new InjectionToken<AuthProvider>('AuthProvider');
